var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPytorch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9548 0V11.6478L22.2162 29.5442C12.9325 39.0438 12.9336 54.3256 22.2193 63.9977L22.5035 64.289C31.9898 74.0407 47.5621 74.0407 57.2276 64.289C66.7962 54.8137 66.892 39.3204 57.5146 29.5496L57.2276 29.2549L63.1341 23.2956C76.0214 36.2979 76.0214 57.1558 63.1341 70.2483C50.5154 83.2506 29.7525 83.2506 16.8652 70.2483C4.10653 57.3761 3.97917 36.7162 16.4824 23.6881L16.8652 23.2956L39.9548 0ZM51.5893 13.1827C53.9617 13.1827 55.8851 15.1233 55.8851 17.5168C55.8851 19.9106 53.9617 21.8509 51.5893 21.8509C49.2167 21.8509 47.2936 19.9106 47.2936 17.5168C47.2936 15.1233 49.2167 13.1827 51.5893 13.1827Z",
    fill: "#EE4C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorch);
export default __webpack_public_path__ + "static/media/pytorch.a8e5e035eb7bae9d37d68111775f0bb2.svg";
export { ForwardRef as ReactComponent };